import { MetadataPutEnum } from './../../../../models/enums/metadata-put-enum';
import { GroupKeyService } from '@shared/services/competition/group-key.service';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { InscricaoEtapaDto } from '@models/embate/clash-dto';
import { IPage } from '@models/pagination/page';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';
import { IPageable } from '@models/pagination/pageable';

@Component({
  selector: 'sigecom-modal-add-registrations-for-key',
  templateUrl: './modal-add-registrations-for-key.component.html'
})
export class ModalAddRegistrationsForKeyComponent extends BaseComponent implements OnInit {

  incTxResumo!: string;

  #groupKeyService = inject(GroupKeyService);

  participants!: IPage<InscricaoEtapaDto>;
  participantsPageable: IPageable = {page: 0, size: 50}

  participantsIdsAdded: number[] = []
  totalParticipants: number = 0;

  @Input({required: true})petNrId! : number;
  @Input({required: true})cheNrId! : number;
  @Output() viewRegistrations = new EventEmitter<number>();

  ngOnInit(): void {
    this.#fetchParticipants();
  }
  #fetchParticipants(){
    this.#groupKeyService.listarInscricoesEtapa(
      { petNrId: this.petNrId, incTxResumo: this.incTxResumo }, this.participantsPageable
    ).subscribe({
      next: (data) => this.participants = data,
    })
  };
  protected incTxResumoChange($event: string) {
    console.log($event);
    this.incTxResumo = $event;
    this.#fetchParticipants();
  }
  openModalViewParticipants(incNrId: number) {
    this.viewRegistrations.emit(incNrId);
  }
  onPageChange(page: number){
    this.participantsPageable.page = page;
    this.#fetchParticipants();
  }
  addParticipant(ineNrId: number) {
    this.#groupKeyService.vincularManual({
      cheNrId: this.cheNrId, ineNrId: ineNrId,
    }).subscribe({
      next: () => {
        this.participantsIdsAdded.push(ineNrId);
        this.totalParticipants = this.participantsIdsAdded.length
      }
    });
  }

  removeParticipant(ineNrId: number) {
    this.#groupKeyService.deletarInscricaoChave(this.cheNrId, ineNrId).subscribe({
      next: () => {
        this.participantsIdsAdded = this.participantsIdsAdded.filter(p => p !== ineNrId);
        this.#fetchParticipants();
      }
    });
  }

  isAdded(id: number):boolean{
    return this.participantsIdsAdded.some(p => p === id)
  }
}
